module.exports = __webpack_public_path__ + "img/werfkast.5c49845f.svg";